module.exports = __webpack_public_path__ + "img/aboutUsImg.8a97e131.png";